import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

const HEIC_MIME_TYPES = ["image/heic", "image/heif"];

// iPhoneが撮影するHEIC/HEIFは、ブラウザ（特にChrome/Firefox/Android WebView）や
// 旧Androidで表示できない。typeが空で渡ってくる端末もあるため拡張子でも判定する。
const isHeic = (file) => {
    if (!file) {
        return false
    }
    const type = (file.type || "").toLowerCase()
    if (HEIC_MIME_TYPES.includes(type)) {
        return true
    }
    return /\.(heic|heif)$/i.test(file.name || "")
}

// HEIC/HEIFをJPEGへ変換する。heic2anyはlibheifのWASMを内包しており、
// ネイティブにHEICをデコードできないブラウザでも変換できる。
// サーバー（Shrine）はimage/jpegとして受理・保存するため、後続の配信もそのまま表示できる。
const convertHeicToJpeg = async (file) => {
    const converted = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
    })
    // heic2anyは単一Blob、または複数フレーム時にBlob配列を返す
    const blob = Array.isArray(converted) ? converted[0] : converted
    const baseName = (file.name || "image").replace(/\.(heic|heif)$/i, "")
    return new File([blob], `${baseName}.jpg`, {
        type: "image/jpeg",
        lastModified: file.lastModified || Date.now(),
    })
}

const compressImage = async (file, options = {}) => {
    if (!file) {
        return file
    }

    // 圧縮の前にHEIC→JPEG変換する。変換に失敗した場合は元ファイルのまま後続へ進め、
    // 最終的にサーバー側バリデーションで弾く（従来挙動）。
    if (isHeic(file)) {
        try {
            file = await convertHeicToJpeg(file)
        } catch (error) {
            console.error("HEIC to JPEG conversion failed", error)
        }
    }

    if (file.size < 5 * 1024 * 1024) {
        return file
    }

    const defaultOptions = {
        maxSizeMB: 5,
        useWebWorker: true,
    }

    try {
        const compressedFile = await imageCompression(file, {
            ...defaultOptions,
            ...options,
        });

        return compressedFile
    } catch (error) {
        console.error(error)
        return file
    }
}

export default compressImage
export { isHeic, convertHeicToJpeg }
